import request from 'utils/request';

export function fetchTemplatePreview(params = {}, options) {
  const requestOptions = {
    ...options,
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };
  return request(
    `/api/v3/survey-templates/${params.templateId}`,
    requestOptions,
  );
}

export function createFromTemplate(params = {}, options) {
  const { templateId, folderId, ...payload } = params;
  const requestOptions = {
    ...options,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    params: { folderId },
  };
  return request(`/api/v3/survey-templates/${templateId}`, requestOptions);
}

// Open AI related
export function fetchGeneratedSurvey(params = {}, options) {
  const { prompt, questionTypeOption } = params;
  const requestOptions = {
    ...options,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ prompt, survey_type: questionTypeOption }),
  };
  return request(`/api/v3/open-ai`, requestOptions);
}
export function createFromGeneratedSurvey(params = {}, options) {
  const { folderId, ...payload } = params;
  const requestOptions = {
    ...options,
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
    params: { folderId },
  };
  return request(`/api/v3/survey-ai`, requestOptions);
}
